import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 32 32"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "Airline Logos" }, [
      _createElementVNode("circle", {
        id: "Ellipse 8",
        cx: "16",
        cy: "16",
        r: "15.5",
        fill: "var(--fill-0, white)",
        stroke: "var(--stroke-0, #9C8761)"
      }),
      _createElementVNode("path", {
        id: "path196",
        fill: "var(--fill-0, #9C8761)",
        "fill-rule": "evenodd",
        d: "M6 16.03 22.04 26c.356-2.41-1.88-3.834-1.901-4.043-.024-.266 1.78-.931 1.913-2.757.225-3.047-3.95-3.24-4.093-.962-.076 1.191 1.25 1.218 1.292.333.057-1.184 1.285-.96 1.475.372.193 1.336-1.363 1.9-1.985 1.883-.969-.03-2.257-.818-2.374-1.984-.161-1.605 1.653-1.812-.687-1.615-.92.077-1.59-.414-2.017-1.204.53-.734 1.097-1.245 2.017-1.167 2.34.2.526-.01.687-1.63.117-1.176 1.405-1.974 2.374-2.003.622-.019 2.178.552 1.985 1.9-.19 1.345-1.418 1.57-1.475.376-.042-.894-1.368-.866-1.292.337.144 2.299 4.318 2.104 4.093-.972-.131-1.806-1.87-2.488-1.912-2.768-.023-.148 2.248-1.71 1.9-4.096",
        "clip-rule": "evenodd"
      })
    ], -1)
  ]))]))
}
export default { render: render }